import React,{useContext} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchProvidersList } from '../../stores/slices/medicalSlice';
import Dropdown from '../input/Dropdown'
import Input from '../input/Input'
import { language } from '../../stores/slices/languageSlice'
import { UserContext } from '../../stores/Context/Context';

function Medical() {
  let contT = useContext(UserContext);
  const selectedLanguage = useSelector(language).Appintake.medical
  const medicalDetails = useSelector(state => state.medicalSlice);
  const dispatch = useDispatch();

  const searchProviders = () => {
  dispatch(fetchProvidersList(medicalDetails.treatingPhysician));
  }
  const patientInformation = useSelector(
      (state) => state.patientSearchSlice.patientInformation
    );
  function isValidatefun() {
  return true
  }

  contT.formValidation.isValidate=isValidatefun
  return (
  <React.Fragment>
    <div className="intro-y g-col-12 g-col-sm-12 text-center p-4 lh-6">
    <h3 className="fw-bold pt-0 fs-xl">{patientInformation.Program == "CPR" ? selectedLanguage.searchTreatingPhysicianCPR : selectedLanguage.searchTreatingPhysician}</h3>
    <p>{patientInformation.Program == "CPR" ? selectedLanguage.stateandCityCPR : selectedLanguage.stateandCity}</p>
    <p>{selectedLanguage.additionalInfo}</p>
    </div>
    <div className="border border-gray-700 dark-border-dark-5 container p-10">
    <div className="grid columns-12 gap-4 gap-y-5  rounded p-5 npisearch ">
      <div className="intro-y g-col-12 g-col-sm-4 ">
      <Dropdown id={"input-wizard-6"} label={selectedLanguage.state} options={["State-1", "State-2", "State-2"]} />
      </div>
      <div className="intro-y g-col-12 g-col-sm-4">
      <Input id={"input-wizard-3"} type={"text"} label={selectedLanguage.state} />
      </div>
      <div className="intro-y g-col-12 g-col-sm-4">
      <Input id={"input-wizard-3"} type={"text"} label={selectedLanguage.firstName} />
      </div>
      <div className="intro-y g-col-12 g-col-sm-4">
      <Input id={"input-wizard-3"} type={"text"} label={selectedLanguage.lastName} />
      </div>
      <div className="intro-y g-col-12 g-col-sm-4">
      <Input id={"input-wizard-5"} type={"text"} label={selectedLanguage.zipcode} />
      </div>
      <div className="intro-y g-col-12 g-col-sm-4 mt-5 text-center">
      <div className="intro-y g-col-12 d-flex align-items-center justify-content-center  p-2 ">
        <button className="btn btn-primary w-24 ms-2">{selectedLanguage.reset}</button>
        <button className="btn btn-primary w-24 ms-2" onClick={searchProviders}>{selectedLanguage.search}</button>
      </div>
      </div>

    </div>

    <div className="grid columns-12 gap-4 gap-y-5 text-start mt-5 p-4 box zoom-in Add-details-card">
      <div className="intro-y g-col-12 g-col-sm-3">
      <b>{selectedLanguage.firstName} </b>
      <p>Hunter</p>
      </div>
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.lastName} </b>
      <p>man</p>
      </div>
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.city} </b>
      <p>	Chennai</p>
      </div>
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.address} </b>
      <p>village</p>
      </div>
    </div>
    <div className="grid columns-12 gap-4 gap-y-5 text-start mt-5 p-4 box zoom-in Add-details-card">
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.firstName}</b>
      <p>Hunter</p>
      </div>
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.lastName} </b>
      <p>man</p>
      </div>
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.city} </b>
      <p>	Chennai</p>
      </div>
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.address} </b>
      <p>village</p>
      </div>
    </div>
    <div className="grid columns-12 gap-4 gap-y-5 text-start mt-5 p-4 box zoom-in Add-details-card">
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.firstName} </b>
      <p>Hunter</p>
      </div>
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.lastName} </b>
      <p>man</p>
      </div>
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.city} </b>
      <p>	Chennai</p>
      </div>
      <div className="intro-y g-col-12 g-col-sm-3">
      <b> {selectedLanguage.address} </b>
      <p>village</p>
      </div>
    </div>
    </div>
    <div className="grid columns-12 gap-4 gap-y-5 mt-5">
    <div className="intro-y g-col-12 g-col-sm-12 text-center border-1 p-1">
      <p className="fw-bold pt-0 fs-xl">{selectedLanguage.primaryDiagnosis}</p>
    </div>
    <div className="intro-y g-col-12 g-col-sm-8">
      <div><b>{selectedLanguage.primaryDiagnosis}</b></div>
      <div>Electrolyte Imbalance</div>
    </div>
    <div className="intro-y g-col-12 g-col-sm-4">
      <label htmlFor="input-wizard-3" className="form-label">{selectedLanguage.DOD}</label>
      <input id="input-wizard-5" type="text" className="form-control" />
    </div>
    </div>
  </React.Fragment>
  )
}

export default Medical